import React, { useState } from 'react';

interface AccordionSectionProps {
  title: string;
  subtitle: string;
  children: React.ReactNode;
}

export const AccordionSection: React.FC<AccordionSectionProps> = ({ 
  title, 
  subtitle, 
  children 
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleOpen = () => {
    setIsOpen(!isOpen);
  };

  return (
    <div className="border-b border-gray-200 dark:border-gray-700/50 last:border-b-0">
      <button 
        className="w-full py-3 flex justify-between items-center text-left focus:outline-none hover:bg-gray-50 dark:hover:bg-gray-800/20 transition-colors"
        onClick={toggleOpen}
        aria-expanded={isOpen}
      >
        <div>
          <h3 className="font-medium text-gray-700 dark:text-gray-300 text-base">{title}</h3>
          <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">{subtitle}</p>
        </div>
        <div className="ml-4 text-gray-500 dark:text-gray-400">
          <svg 
            className={`w-4 h-4 transform transition-transform duration-200 ${isOpen ? 'rotate-180' : ''}`} 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24" 
            xmlns="http://www.w3.org/2000/svg"
          >
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </button>
      
      {isOpen && (
        <div className="px-4 py-3 text-sm border-t border-gray-100 dark:border-gray-700/30">
          {children}
        </div>
      )}
    </div>
  );
};
